module.exports = __webpack_public_path__ + "img/pd-img49.cf158059.jpg";